export const internalMessageExpandLocalStorageKey = 'internalMessageIsExpanded';
